var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1950_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#E16B5A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M511.904 259.723L386.213 134.059L386.16 134.006L378.693 126.539C377.093 124.939 375.44 123.392 373.786 121.952C364.346 113.525 355.653 107.552 353.466 109.792L323.279 139.979L311.919 151.339L127.28 335.925C125.947 337.258 125.36 339.178 125.467 341.258C125.467 341.258 125.467 341.258 125.414 341.311L115.334 374.271L109.574 392.991C108.827 395.284 109.947 397.898 111.761 399.818L111.974 400.031L221.526 509.62C232.805 511.141 244.299 512 256 512C396.139 512 509.909 399.381 511.904 259.723Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1950_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.218 117.476C386.234 114.493 382.189 112.818 377.97 112.818C377.968 112.818 377.966 112.818 377.964 112.818L314.328 112.837C305.543 112.839 298.424 119.961 298.424 128.746V383.273C298.424 392.06 305.547 399.183 314.333 399.183H377.97C386.756 399.183 393.879 392.06 393.879 383.273V128.726C393.879 124.507 392.202 120.459 389.218 117.476Z",
    fill: "#99602E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.559 84.7214C320.955 81.6986 316.202 80.425 311.568 81.2426L131.264 113.08C123.662 114.422 118.121 121.027 118.121 128.746V383.273C118.121 390.993 123.664 397.598 131.266 398.94L311.57 430.758C312.489 430.92 313.414 431 314.333 431C318.045 431 321.672 429.7 324.559 427.278C328.161 424.256 330.243 419.794 330.243 415.091V96.9086C330.243 92.2061 328.162 87.7436 324.559 84.7214Z",
    fill: "#E78244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.559 84.7214C320.955 81.6986 316.202 80.425 311.568 81.2426L224.182 96.672V415.338L311.57 430.758C312.489 430.92 313.414 431 314.333 431C318.045 431 321.672 429.7 324.559 427.278C328.161 424.256 330.243 419.794 330.243 415.091V96.9086C330.243 92.2061 328.162 87.7436 324.559 84.7214Z",
    fill: "#D97A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.513 282.515C278.324 282.515 274.228 280.818 271.269 277.859C268.3 274.9 266.604 270.795 266.604 266.606C266.604 262.417 268.3 258.322 271.269 255.352C274.228 252.393 278.333 250.696 282.513 250.696C286.701 250.696 290.806 252.393 293.765 255.352C296.724 258.322 298.422 262.416 298.422 266.606C298.422 270.795 296.724 274.9 293.765 277.859C290.806 280.818 286.701 282.515 282.513 282.515Z",
    fill: "#F2CF61"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1950_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1950_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "white",
    transform: "translate(81 81)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.94b2f3ba34a80f933a019a030c0250cc.svg";
export { ForwardRef as ReactComponent };